import axios from "axios"
import { logOut } from "../actions/AuthAction";
import store from '../store/ReduxStore';

const API = axios.create({baseURL: process.env.REACT_APP_API_BASE_URL, withCredentials: true})

API.interceptors.response.use(
    response => response, 
    error => {
        if (error.response && error.response.status === 401) {
            console.log("Token expired, logging out user...");

            // Dispatch logout action
            store.dispatch(logOut());
        }
        return Promise.reject(error);
    }
);

export const create_note = (c_flag,title,text) => API.put(`/note/${c_flag}/${title}/${text}`);
export const delete_note = (Note_id) => API.get(`note/deleteNote/${Note_id}`);
export const fetchAllNote = (notetype,user_id) => API.get(`note/getAllNote/${notetype}/${user_id}`);
export const fetchNoteCount = (User_id) => API.get(`note/getNoteCount/${User_id}`);
export const makeReadNote = (Note_id,userID) => API.get(`note/makeReadNote/${Note_id}/${userID}`);